import React from "react";
import defaultI18nKeys from "./defaultI18nKeys";
import I18nMessageComponent from "./I18nMessageComponent";

export default (props) => (
    <I18nMessageComponent {...props} defaultI18n={defaultI18nKeys.OK} />
);
